import { defineComponent, createElementBlock, openBlock, createCommentVNode, toDisplayString, createElementVNode, Fragment, renderList, createBlock } from 'vue';
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */

const _hoisted_1 = { class: "nav-social" };
const _hoisted_2 = {
  key: 0,
  class: "nav-social__headline"
};
const _hoisted_3 = {
  key: 1,
  class: "nav-social__copy"
};
const _hoisted_4 = {
  key: 2,
  class: "nav-social__nav"
};
const _hoisted_5 = { class: "nav-social__list" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavSocial",
  props: {
    title: {},
    text: {},
    items: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        props.title ? (openBlock(), createElementBlock("h4", _hoisted_2, toDisplayString(props.title), 1)) : createCommentVNode("", true),
        props.text ? (openBlock(), createElementBlock("p", _hoisted_3, toDisplayString(props.text), 1)) : createCommentVNode("", true),
        Array.isArray(props.items) && props.items.length > 0 ? (openBlock(), createElementBlock("nav", _hoisted_4, [
          createElementVNode("ul", _hoisted_5, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (navItem) => {
              return openBlock(), createElementBlock("li", {
                key: navItem.text,
                class: "nav-social__list-item"
              }, [
                navItem.link && navItem.link.uri ? (openBlock(), createBlock(_sfc_main$1, {
                  key: 0,
                  "icon-type": "icon-only",
                  size: "large",
                  styleType: "primary",
                  "icon-name": navItem.iconName,
                  link: navItem.link.uri,
                  target: navItem.link.target,
                  rel: navItem.link.rel,
                  "aria-label": navItem.text
                }, null, 8, ["icon-name", "link", "target", "rel", "aria-label"])) : createCommentVNode("", true)
              ]);
            }), 128))
          ])
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
